import SearchBar from "./SearchBar";
import { Typography } from "@mui/material";
import "./BgAccueilStyle.css";

const BgAccueil = ({ t, sites, locations }) => {
  return (
    <div className="bkg-Accueil">
      <div className="container-Accueil">
        {/* <img className="bg-img-Accueil" src={image} alt="background" /> */}
        <video
          className="bg-img-Accueil"
          alt="background video"
          autoPlay
          muted
          playsInline
          loop
          preload="none"
          onContextMenu={(e) => e.preventDefault()}
        >
          <source src="/videos/bg-home.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="content-Accueil">
        <div className="search-section-accueil">
          <SearchBar t={t} sites={sites} locations={locations} />
          <Typography className="title-accueil" variant="h1" gutterBottom>
            {t("home_header")}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default BgAccueil;
